import React, {useRef, useEffect, forwardRef, useImperativeHandle} from 'react';

const WebComponent = forwardRef(({tagName, attrs = {}, events = {}, children}, forwardedRef) => {
  const internalRef = useRef();

  // Expose the internal ref to the forwarded ref
  useImperativeHandle(forwardedRef, () => internalRef.current);

  useEffect(() => {
    const {current: elem} = internalRef;

    const setupElement = async () => {
      try {
        await window.customElements.whenDefined(tagName);

        Object.keys(attrs).forEach((key) => {
          elem[key] = attrs[key];
        });

      } catch (error) {
        console.warn(`Failed to setup ${tagName}:`, error);
      }
    };

    const eventNames = Object.keys(events);
    eventNames.forEach((eventName) => {
      elem.addEventListener(eventName, events[eventName]);
    });

    setupElement();

    return () => {
      eventNames.forEach((eventName) => {
        elem.removeEventListener(eventName, events[eventName]);
      });
    };
  }, [internalRef, attrs, events, tagName]);

  return React.createElement(tagName, {ref: internalRef}, children);
});

WebComponent.displayName = 'WebComponent';

export default WebComponent;
